import { gql, TypedDocumentNode } from "@apollo/client";

import {
  IntentResourceOperationReview,
  MutationIntentResourceOperationReviewArgs,
} from "types/generated";

export const REVIEW_INTENT_RESOURCE_OPERATION: TypedDocumentNode<
  { intentResourceOperationReview: IntentResourceOperationReview },
  MutationIntentResourceOperationReviewArgs
> = gql`
  mutation ReviewIntentResourceOperation(
    $intentProject: ID!
    $operationID: ID!
    $decision: IntentResourceOperationReviewDecision!
    $note: String
  ) {
    intentResourceOperationReview(
      intentProject: $intentProject
      operationID: $operationID
      decision: $decision
      note: $note
    ) {
      id
      author
      decision
      note
      timestamp
    }
  }
`;
